import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ContactListItem from "../contact/ContactListItem";

class ClientContactsList extends Component{
    render(){

        const {contacts, client_id} = this.props

        return(
            <div className="d-flex flex-column">
                {contacts && contacts.map(contact => <ContactListItem client_id={client_id} key={contact.contact_id} {...contact}/>)}
            </div>
        )
    }
}

ClientContactsList.propTypes = {
    client_id: PropTypes.number.isRequired,
    contacts: PropTypes.array.isRequired
}

export default ClientContactsList